import {isNil} from 'ramda';

import i18n from '@dms/i18n';

import {isValidEmail, yupString} from 'shared/web';

/**
 * A trimmed customer e-mail in the format the DMS API accepts. An empty value means no e-mail;
 * add `.required()` where the e-mail is mandatory.
 */
export const yupCustomerEmail = yupString.test(
  'customerEmail',
  () => i18n.t('general.validations.invalidEmail'),
  (value) => isNil(value) || value === '' || isValidEmail(value)
);
